import tonStyles from './../ton.json'

export default {
  color: tonStyles.colors.SecondaryGrey,
  iconColor: tonStyles.colors.SecondaryGrey,
  dashLength: 16,
  dashHeight: 2
}
